/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Permissions from 'react-redux-permissions';
import Clickable from '../../../../../components/clickable/Clickable';
import Button from '../../../../../components/button';
import Checkbox from '../../../../../components/checkbox';
import PulpoField from '../../../../../pulpo_visualizer/fields';
import FormattedMessageWithClassName from '../../../../../components/formattedMessageWithClass';
import TagComponent from '../../../../../components/tags';
import Collapsible from '../../../../../components/collapsible/Collapsible';
import { getShiftTypeByDate, checkConditionalValue } from '../../../../../utils/helpers';
import {
  TIME_BASED_SHIFT,
  DROPDOWN_BASED_SHIFT
} from '../../../../../constants/ModelStatus';

import fieldstyles from '../../../../../pulpo_visualizer/fields/fields.module.scss';
import styles from './details.module.scss';

class InspectionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: undefined,
      activeCategory: {},
      hours: undefined,
      minutes: undefined,
      mileage: undefined
    };
    this.handleAutocompleteChange = this.handleAutocompleteChange.bind(this);
    this.handleAutocompleteSelect = this.handleAutocompleteSelect.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.currentValue === undefined && props.answers.inspected_by) {
      return { ...state, currentValue: props.answers.inspected_by.fullname };
    }
    if (!props?.answers?.shiftName && props?.shiftTypes) {
      const shift = getShiftTypeByDate(props.answers.date, props.shiftTypes);
      if (shift) {
        props.handleAnswerChanged(shift.name, 'shiftName');
      }
    }
    return state;
  }

  componentDidUpdate() {
    const {
      shiftSetting,
      answers,
      shiftTypes
    } = this.props;
    if (shiftSetting === TIME_BASED_SHIFT) {
       getShiftTypeByDate(
        answers.date,
        shiftTypes
      );
    }
  }

  // eslint-disable-next-line consistent-return
  handleFieldDisplay = (field) => {
    const { edit, answers } = this.props;
    if ((edit && !field.display_with_checklist) || (!field?.display_separately && !field?.display_with_checklist)) {
      if (!field.conditional) {
        return true;
      } if (
        field.conditional
        && answers[field?.conditional_field?.key]
        && checkConditionalValue(field, answers)
      ) {
        return true;
      }
      return false;
    }
  }

  handleChange = (a, b) => {
    const { handleAnswerChanged } = this.props;

    if (/^[0-9:.]*$/.test(a)) {
      const validated = a?.match(/^(\d*\.{0,1}\d{0,2}$)/);
      // eslint-disable-next-line no-useless-escape
      const validated2 = a?.match(/^(\d*\:{0,1}\d{0,2}$)/);

      if (validated) {
        let decimalTime = parseFloat(a);
        let hrs = Math.floor(decimalTime);
        let min = Math.round((decimalTime % 1) * 60);
        this.setState({ hours: hrs, minutes: min });
        handleAnswerChanged(a, b);
      } else if (validated2) {
        let decimalTime = a?.split(':');
        let hrs = +decimalTime[0];
        let min = +decimalTime[1];
        if (min >= 0 && min <= 59) {
          this.setState({ hours: hrs, minutes: min });
          handleAnswerChanged(a, b);
        }
      }
    }
  }

  handleAutocompleteChange(e) {
    this.setState({ currentValue: e.target.value });
  }

  handleAutocompleteSelect(val, item) {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;

    this.setState({ currentValue: val });
    handleAnswerChanged(item, 'inspected_by');
    handleFieldErrorChanged('inspected_by', false);
  }

  render() {
    const { currentValue, activeCategory } = this.state;
    const {
      detailsForm,
      userlist,
      translations,
      handleAnswerChanged,
      answers,
      showFormErrors,
      handleFieldErrorChanged,
      handleGoToChecklist,
      requiredMap,
      edit,
      answer,
      shiftTypes,
      allDataSources,
      shiftSetting,
      DateError,
      handleSelectedCategories,
      categories,
      selectedCategory,
      handleGoInspections,
      supplementInspection,
      signData,
      handleSignData,
      settings,
      opslog_tags,
      handleRemoveTag,
      match,
      user,
      groups
    } = this.props;

    let titles ={
      detail: { id: 'inspections.complete_inspection.details', default: 'Inspection Details' },
      inspected_by: { id: 'inspections.complete_inspections.by', default: 'Inspected By' },
      start_time: { id: 'inspections.complete_inspections.date', default: 'Inspection - Start Date and Time' },
      end_time: { id: 'inspections.complete_inspections.enddate', default: 'Inspection - End Date and Time' },
      button_title: answer
                    ? { id: 'inspections.edit_inspection.title', default: 'Edit Inspection' }
                    : { id: 'inspections.start_inspection.title', default: 'Start Inspection' },
      supplemental_inspection: { id: 'inspections.complete_inspection.supplemental', default: 'Inspections' },
      supplemental_select_inspection: { id: 'inspections.complete_inspection.select_inspection', default: 'Select Inspections & Checklist' }
    };

    if (match?.url?.includes('sms')) {
      titles = {
        detail: { id: 'safetyAudits.complete_audit.details', default: 'Audit Details' },
        inspected_by: { id: 'safetyAudit.complete_audit.by', default: 'Audited By' },
        start_time: { id: 'safetyAudit.complete_audit.date', default: 'Audit - Start Date and Time' },
        end_time: { id: 'safetyAudit.complete_audit.enddate', default: 'Audit - End Date and Time' },
        button_title: answer
                      ? { id: 'safetyAudit.edit_audit.title', default: 'Edit Audit' }
                      : { id: 'safetyAudit.start_audit.title', default: 'Start Audit' },
        supplemental_inspection: { id: 'safetyAudit.complete_audit.supplemental', default: 'Audits' },
        supplemental_select_inspection: { id: 'safetyAudit.complete_audit.select_audit', default: 'Select Audits & Checklist' }
      };
    }

    const airportData = {
      location: user?.portal_airport?.location?.coordinates,
      map_style: user?.portal_airport?.airport_settings?.map_style
    };

    let checklistGroups = groups;
    if (!checklistGroups?.length) {
      checklistGroups = [{
        'title': '',
        'fields': categories?.map(cat => cat?.id)
      }];
    }
    return (
      <div className={styles.details}>
        <div>
          <div className={styles.header}>
            <FormattedMessage
              id={titles.detail.id}
              defaultMessage={titles.detail.default}
            />
          </div>
          <p className={styles.details_header}>
            <FormattedMessage
              id="inspections.complete_inspection.review_data"
              defaultMessage=""
            />
          </p>
          <p className={styles.instructions}>{detailsForm.additionalInfo}</p>
          <div className={styles.details_form}>
            {edit && (
            <div className={`${styles.shift} ${fieldstyles.field}`}>
              <FormattedMessageWithClassName
                id={titles.inspected_by.id}
                defaultMessage={titles.inspected_by.default}
                className={fieldstyles.title}
              />
              <Autocomplete
                getItemValue={item => item.fullname}
                items={userlist}
                wrapperStyle={{ position: 'relative' }}
                renderMenu={children => (
                  <div className={styles.autocompleteMenu}>{children}</div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div
                    key={item.id}
                    className={`${styles.menuItem} ${isHighlighted
                      && styles.highlighted}`}
                  >
                    {item.fullname}
                  </div>
                )}
                value={currentValue}
                onChange={this.handleAutocompleteChange}
                onSelect={this.handleAutocompleteSelect}
              />
              {!currentValue && showFormErrors && (
                <small>
                  <FormattedMessage
                    id="pulpoforms.errors.not_blank"
                    defaultMessage="There is an error in this field"
                  />
                </small>
              )}
            </div>
            )}
          </div>
          <div className={styles.details_form}>
            {edit && (
              <>
                <PulpoField
                  key="start_date"
                  id="start_date"
                  type="datetime"
                  title={titles.start_time.default}
                  isRequired
                  fromMeeting
                  translationID={titles.start_time.id}
                  handleValueChange={handleAnswerChanged}
                  answer={answers?.start_date}
                  showFieldErrors={showFormErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                />
                <PulpoField
                  key="date"
                  id="date"
                  type="datetime"
                  title={titles.end_time.default}
                  isRequired
                  fromMeeting
                  translationID={titles.end_time.id}
                  handleValueChange={handleAnswerChanged}
                  answer={answers.date}
                  showFieldErrors={showFormErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                />
                {edit && DateError && (
                <small style={{ color: 'red' }}>
                  <FormattedMessage
                    id="tenant.lease.date_error"
                    defaultMessage="Start Date Should be lesser than End Date"
                  />
                </small>
                )}
              </>
            )}
          </div>
          <div className={styles.details_form}>
            {!edit && (
              <PulpoField
                key="date"
                id="date"
                type="datetime"
                title={titles.start_time.default}
                isRequired
                fromMeeting
                formField
                translationID={titles.start_time.id}
                handleValueChange={handleAnswerChanged}
                answer={answers.date}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
              />
            )}

            {!edit && (
              <div className={`${styles.shift} ${fieldstyles.field}`}>
                <FormattedMessageWithClassName
                  id={titles.inspected_by.id}
                  defaultMessage={titles.inspected_by.default}
                  className={fieldstyles.title}
                />
                <Autocomplete
                  getItemValue={item => item.fullname}
                  items={userlist}
                  wrapperStyle={{ position: 'relative' }}
                  renderMenu={children => (
                    <div className={styles.autocompleteMenu}>{children}</div>
                  )}
                  renderItem={(item, isHighlighted) => (
                    <div
                      key={item.id}
                      className={`${styles.menuItem} ${isHighlighted
                      && styles.highlighted}`}
                    >
                      {item.fullname}
                    </div>
                  )}
                  value={currentValue}
                  onChange={this.handleAutocompleteChange}
                  onSelect={this.handleAutocompleteSelect}
                />
                {!currentValue && showFormErrors && (
                <small>
                  <FormattedMessage
                    id="pulpoforms.errors.not_blank"
                    defaultMessage="There is an error in this field"
                  />
                </small>
                )}
              </div>
            )}
            {shiftSetting === TIME_BASED_SHIFT && (
              <div className={styles.shift}>
                <div>
                  <FormattedMessage
                    id="inspections.complete_inspections.shift"
                    defaultMessage="Shift"
                  />
                </div>
                <br />
                <input
                  type="text"
                  disabled
                  name="Shift"
                  value={answers && answers.shiftName}
                />
              </div>
            )}
            {shiftSetting === DROPDOWN_BASED_SHIFT && (
              <div className={styles.shift}>
                <PulpoField
                  key="shiftName"
                  id="shiftName"
                  type="select"
                  title="Shift"
                  widget={{ type: 'dropdown' }}
                  translationID="inspections.complete_inspections.shift"
                  defaultMessage="Shift"
                  handleValueChange={handleAnswerChanged}
                  answer={answers.shiftName}
                  values={
                    shiftTypes
                    && shiftTypes.map(shift => ({
                      key: shift.name,
                      value: shift.name
                    }))
                  }
                  showFieldErrors={showFormErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                />
              </div>
            )}
          </div>
          <div className={styles.details_form}>
          {detailsForm?.fields?.map(field => (
              <>
                    {field?.dataSourceID !== 'ds3' && field?.dataSourceID !== 'ds4'
                    && field?.dataSourceID !== 'ds10'
                    && this.handleFieldDisplay(field)
                    && (
                      <>
                        {field?.type !== 'multi_level' && field?.type !== 'header' && field?.type !== 'map_location' && (
                          <>
                            <PulpoField
                              key={field.id}
                              {...field}
                              translation={translations && translations[field.title]}
                              handleValueChange={handleAnswerChanged}
                              isRequired={requiredMap[field.id]}
                              answer={answers[field.id]}
                              fromMeeting
                              showFieldErrors={showFormErrors}
                              disabled={(field.type === 'string' && field?.hide_default_text)}
                              handleFieldErrorChanged={handleFieldErrorChanged}
                              allDataSources={allDataSources}
                              isInspection
                              signData={signData}
                              className={field.full_width ? styles.fullWidth : ''}
                              handleSignData={handleSignData}
                              getMileageUsage={this.getMileageUsage}
                              detailsForm={detailsForm}
                            />
                          </>
                        )}
                        {field.type === 'map_location' && (
                          <PulpoField key={field.id} {...field} airportInfo={airportData}
                            handleValueChange={handleAnswerChanged}
                            isRequired={requiredMap[field.id]} answer={answers[field.id]}
                            showFieldErrors={showFormErrors}
                            handleFieldErrorChanged={handleFieldErrorChanged}
                            className={styles.fullWidth} addressEnabled={field?.address_location}
                            title={field?.address_location ? 'Address' : field.title}
                            translationID={field?.address_location ? 'custom_field.address.title' : field.title}
                          />
                        )}
                      {field?.type === 'multi_level'
                        && <>
                              {/* don't even change the props passing position here,
                              it will raise not displaying or page break issues */}
                              <PulpoField
                                {...field}
                                levels={{
                                  level_0: {
                                      title: `${field?.title}`
                                  },
                                  level_1: {
                                      title: `${field?.title} 1`
                                  },
                                  level_2: {
                                      title: `${field?.title} 2`
                                  }
                                }}
                                title={field?.title}
                                values={typeof field.values === 'object'
                                ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                                handleValueChange={handleAnswerChanged}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                isRequired={requiredMap[field.id]}
                                showFieldErrors={showFormErrors}
                                forFormModule
                                answer={answers && answers[field.id]}
                                type="dataSourceMultiLevel"
                                key={field.id}
                                translation={translations && translations[field.title]}
                                fromMeeting
                                disabled={(field.type === 'string' && field?.hide_default_text)}
                                allDataSources={allDataSources}
                                isInspection
                                signData={signData}
                                handleSignData={handleSignData}
                                getMileageUsage={this.getMileageUsage}
                                detailsForm={detailsForm}
                              />
                           </>
                      }
                      {field?.type === 'header' && (
                        <>
                        {field?.collapsible ? (
                        <div className={styles.collapseHeader}>
                          <Collapsible
                            title={field?.title} openOnMount
                            styleClasses={styles.headerField}
                            inspectionMaxHeight
                          >
                            <div>
                              {/* eslint-disable-next-line react/no-danger */}
                              <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                            </div>
                          </Collapsible>
                        </div>
                        ): (
                        <div style={{ width: '100%' }}>
                          <div className={styles.headerField}>
                            {field?.title}
                          </div>
                          <div>
                            {/* eslint-disable-next-line react/no-danger */}
                            <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                          </div>
                        </div>
                      )}
                        </>
                      )}
                      </>
                    )}
                    {field?.type === 'dataSource' && field?.dataSourceID === 'ds10' && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        translation={field.title}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]}
                        answer={answers && answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        className={styles.fullWidth}
                        type={'wildlife_species'}
                        {...this.props}
                      />
                    )}
              </>
            ))}

          </div>

        </div>
        {supplementInspection && (
          <div className={styles.inspection_category}>
            <div className={styles.header}>
              <FormattedMessage
                id={titles.supplemental_inspection.id}
                defaultMessage={titles.supplemental_inspection.default}
              />
            </div>
            {settings?.supplement_sub_selection === true && (
              <div className={styles.categorySelection}>
                {categories?.map(category => (
                  <>
                    <div
                      className={styles.category}
                      role="button" tabIndex="0" onKeyPress={() => {}}
                      onClick={() => this.setState({ activeCategory: { [category?.id]: !activeCategory?.[category?.id] } })}
                    >
                      <Checkbox
                        id={category?.id}
                        checked={selectedCategory?.[category?.id]
                          && Object.keys(selectedCategory?.[category?.id]).filter(
                            k => (selectedCategory?.[category?.id][k] === true)
                          )?.length > 0
                        }
                        onChange={() => handleSelectedCategories(category, 'all')}
                      />
                      <h3>
                        {category.title}
                        <p>{selectedCategory?.[category?.id]
                          && Object.keys(selectedCategory?.[category?.id]).filter(
                            k => (selectedCategory?.[category?.id][k] === true)
                          )?.length || 0}/{category?.checklist?.length}&nbsp;selected
                        </p>
                      </h3>
                    </div>
                    {activeCategory?.[category?.id] === true && category?.checklist?.map(item => (
                      <div className={styles.subCategory}>
                        <Checkbox
                          id={`${category?.id}-${item.key}`}
                          checked={selectedCategory?.[category?.id]?.[item?.key]}
                          onChange={() => handleSelectedCategories(category, item)}
                        />
                        <h4>{item?.value}</h4>
                      </div>
                    ))}
                  </>
                ))}
              </div>
            )}
            {!settings?.supplement_sub_selection && (
              <div className={styles.singleSelection}>
                {checklistGroups?.map(grp => (
                  <>
                    <h5 className={styles.grp_header}>
                      {grp?.title}
                    </h5>
                    {grp?.fields?.map(field => (
                      <>
                        {categories.map(category => (
                          <>
                            {category?.id === field && (
                              <>
                                <Clickable
                                  className={selectedCategory?.[category?.id]
                                    && Object.keys(selectedCategory?.[category?.id]).filter(
                                      k => (selectedCategory?.[category?.id][k] === true)
                                    )?.length > 0 ? styles.selected : styles.singleCategory}
                                  onClick={() => handleSelectedCategories(category, 'all')}
                                >
                                  {category?.title}
                                </Clickable>
                              </>
                            )}
                          </>
                        ))}
                      </>
                    ))}
                  </>
                ))}
              </div>
            )}
          </div>
        )}
        {settings?.enable_tags
          && <Permissions allowed={['view_log']}>
                <div style={{ width: '100%', border: 'none', minHeight: '120px', padding: '0 75px', marginTop: '20px' }}>
                <TagComponent
                  handleTagSelect={handleAnswerChanged}
                  opsLogTags={opslog_tags}
                  handleTagSelectProps={['tags']}
                  module={'inspections'}
                  handleRemoveTag={handleRemoveTag}
                  updatedOpslogTags={answers?.tags}
                  updatedOpsOldTags={answers?.oldTags}
                  />
                </div>
             </Permissions>
        }
        <div className={styles.footer}>
          <Button
            action="tertiary"
            onClick={handleGoInspections}
            translationID="inspections.new.prev"
            defaultText="Back"
          />
          <Button
            action="secondary"
            onClick={handleGoToChecklist}
            translationID={titles.button_title.id}
            defaultText={titles.button_title.default}
          />
        </div>
      </div>
    );
  }
}

InspectionDetails.propTypes = {
  handleAnswerChanged: PropTypes.func.isRequired,
  detailsForm: PropTypes.shape({
    fields: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  answers: PropTypes.shape({}).isRequired,
  requiredMap: PropTypes.shape({}).isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  handleGoToChecklist: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  answer: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  draftdata: PropTypes.string
};

export default withRouter(InspectionDetails);
